import { switchImages } from './lazy-load';

/**
 * Open/Close filters on mobile
 *
 * @param {node} filtersContainer
 * @param {node} togglersFilters
 * @param {node} checkboxesFilters
 */
const toggleMobileFilters = ( filtersContainer, togglersFilters, checkboxesFilters ) => {

	const mobileFiltersContainer = document.querySelector( '.item-listing__filters' );
	const openFiltersButton = document.querySelector( '.item-listing__filters-open .c-button' );
	const closeFiltersButton = document.querySelector( '.item-listing__filters-close' );

	// open mobile filters container
	if ( openFiltersButton !== null ) {

		openFiltersButton.addEventListener( 'click', () => {

			mobileFiltersContainer.classList.add( 'js-open' );

		} );

	}

	// close mobile filters container and clear all filters
	if ( closeFiltersButton !== null ) {

		closeFiltersButton.addEventListener( 'click', () => {

			// get cloned pageFilters only
			const pageFilters = document.querySelectorAll( '.item-listing__filters .js-tax-filter' );

			mobileFiltersContainer.classList.remove( 'js-open' );
			closeAccordions();
			clearAllFilters( filtersContainer, pageFilters, togglersFilters, checkboxesFilters );

		} );

	}

}

/**
 * Open/Close filter dropdowns (accordions)
 * Clone dropdown content (accordion filters) to display in mobile view
 *
 * @param {node} togglersFilters
 * @param {boolean} isMobile
 */
const toggleFilterDropdown = ( togglersFilters, isMobile ) => {

	// add listener to togglers filters
	selectMobileFilters( togglersFilters );

	// get all pageFilters lists
	const filterDropdowns = document.querySelectorAll( '[data-dropdownTrigger]' );

	filterDropdowns.forEach( ( dropdown ) => {

		const hasDropdown = dropdown.classList.contains( 'accordion-has-dropdown' );
		const dropdownContent = document.querySelector( `[data-dropdown="${ dropdown.dataset.dropdowntrigger }"]` );
		let cloneDropdownContent = false;

		// clone accordion with dropdown to display in mobile view
		if ( isMobile ) {

			if ( ! hasDropdown ) {

				cloneDropdownContent = dropdownContent.cloneNode( true );
				dropdown.classList.add( 'accordion-has-dropdown' );
				dropdown.insertAdjacentElement( 'afterend', cloneDropdownContent );
				// toggle tooltip on mobile
				toggleTooltip( cloneDropdownContent );
				// add listener for all cloned filter inputs
				selectMobileFilters( cloneDropdownContent.querySelectorAll( '.js-tax-filter' ) );

			}

		}

		// toggle accordions with filters
		dropdown.addEventListener( 'click', () => {

			// close all dropdowns except current clicked
			const remainingDropdowns = document.querySelectorAll( `[data-dropdownTrigger]:not([data-dropdownTrigger="${ dropdown.dataset.dropdowntrigger }"])` );
			remainingDropdowns.forEach( ( openDropdown ) => {

				openDropdown.classList.remove( 'js-open' );

			} );

			const remainingDropdownsContent = document.querySelectorAll( `[data-dropdown]:not([data-dropdown="${ dropdown.dataset.dropdowntrigger }"])` );
			remainingDropdownsContent.forEach( ( openDropdownContent ) => {

				openDropdownContent.classList.remove( 'js-open' );

			} );

			// open current dropdown
			dropdown.classList.toggle( 'js-open' );
			if ( isMobile ) {

				cloneDropdownContent.classList.toggle( 'js-open' );

			} else {

				dropdownContent.classList.toggle( 'js-open' );

			}

		} );

	} );

}

/**
 * Toggle taxonomy tooltip
 *
 * @param {node} dropdown
 */
const toggleTooltip = ( dropdown ) => {

	const tooltips = dropdown.querySelectorAll( '.tax-tooltip' );

	if ( tooltips.length > 0 ) {

		tooltips.forEach( ( tooltip ) => {

			// tooltip on center
			const tooltipContent = tooltip.querySelector( '.tax-tooltip__content' );
			let isMobile = window.matchMedia( '(max-width: 992px)' ).matches;
			let tooltipPosLeft = tooltip.getBoundingClientRect().left - 20;
			const tooltipPosRight = tooltip.getBoundingClientRect().right + 20;
			let afterPos = tooltip.getBoundingClientRect().left - 14;

			// set tooltip position on mobile
			if ( tooltipContent && isMobile ) {

				if ( window.innerWidth - tooltipPosRight < 126 ) {

					// tooltip on right
					tooltipPosLeft = 126 - ( window.innerWidth - tooltipPosRight ) + 126 - 6;
					afterPos = 126 - ( window.innerWidth - tooltipPosRight ) + 126;

				} else if ( tooltipPosLeft > 126 ) {

					// tooltip on left
					tooltipPosLeft = 114;
					afterPos = 120;

				}

				tooltipContent.style.left = `-${ tooltipPosLeft }px`;
				tooltipContent.style.setProperty( '--tooltip-after-position', `${ afterPos }px` );

			}

			// toggle tooltip on mobile
			tooltip.addEventListener( 'click', ( e ) => {

				isMobile = window.matchMedia( '(max-width: 992px)' ).matches;

				if ( isMobile && e.target.closest( '.tax-tooltip' ) === tooltip ) {

					// hide all tooltips
					tooltips.forEach( ( singleTooltip ) => {

						const notRemove = tooltip === singleTooltip && tooltip.classList.contains( 'tax-tooltip--visible' );

						if ( ! notRemove ) {

							singleTooltip.classList.remove( 'tax-tooltip--visible' );

						}

					} );

					// show current tooltip
					tooltip.classList.toggle( 'tax-tooltip--visible' );

				}

			} )

		} )

	}

}

/**
 * Close all accordions
 * Mark all dropdowns as closed
 */
const closeAccordions = () => {

	const accordions = document.querySelectorAll( '.item-listing__accordion' );
	const dropdowns = document.querySelectorAll( '.item-listing__filters__dropdown' );

	if ( accordions.length > 0 ) {

		accordions.forEach( ( accodrion ) => {

			accodrion.style.transition = 'none';
			accodrion.classList.remove( 'js-open' );
			accodrion.style.transition = '';

		} )

	}

	if ( dropdowns.length > 0 ) {

		dropdowns.forEach( ( dropdown ) => {

			dropdown.classList.remove( 'js-open' );

		} )

	}

}

/**
 * Select filters on mobile, but not apply it yet
 *
 * @param {node} filters
 */
const selectMobileFilters = ( filters ) => {

	if ( filters.length > 0 ) {

		const isMobile = window.matchMedia( '(max-width: 992px)' ).matches;

		if ( isMobile ) {

			filters.forEach( ( filter ) => {

				filter.addEventListener( 'change', () => {

					const filterName = filter.getAttribute( 'name' )?.replace( '[]', '' );
					const filterValue = filter.getAttribute( 'value' );
					const url = new URL( location );
					const currentParameters = url.searchParams.getAll( filterName );

					if ( filterName && filterValue ) {

						if ( filter.checked ) {

							// add filter
							url.searchParams.append( filterName, filterValue );
							makeAccodrionActive( true, filterName );

						} else if ( currentParameters.includes( filterValue ) ) {

							// remove filter
							url.searchParams.delete( filterName, filterValue );
							makeAccodrionActive( false, filterName );

						}

						// change url parameters
						window.history.pushState( {}, '', url );

					}

				}, )

			} );

		}

	}

}

/**
 * Get selected filters (on mobile)
 *
 * @return {array} array of selected filters
 */
const getSelectedMobileFilters = () => {

	const clonedFilters = document.querySelectorAll( '.item-listing__filters__wrapper .js-tax-filter' );
	const togglersFilters = document.querySelectorAll( '.c-toggle-control__input' );

	const allFilters = [];

	if ( clonedFilters.length > 0 ) {

		clonedFilters.forEach( ( filter ) => {

			if ( filter.checked ) {

				const filterName = filter.getAttribute( 'name' )?.replace( '[]', '' );
				const filterText = filter.dataset.filtername;
				const filterValue = filter.getAttribute( 'value' );

				allFilters.push( { name: filterName, text: filterText, value: filterValue } );

			}

		} );

	}

	if ( togglersFilters.length > 0 ) {

		togglersFilters.forEach( ( filter ) => {

			if ( filter.checked ) {

				const filterName = filter.getAttribute( 'name' )?.replace( '[]', '' );
				const filterText = filter.dataset.filtername;
				const filterValue = filter.getAttribute( 'value' );

				allFilters.push( { name: filterName, text: filterText, value: filterValue } );

			}

		} );

	}

	return allFilters;

}

/**
 * Check if filter button for selected filter exists (on mobile)
 *
 * @param {string} filterName
 * @param {string} filterValue
 *
 * @return {boolean} if button exists
 */
const isFilterButtonExists = ( filterName, filterValue ) => {

	const existingFilterButton = document.querySelector( `.selected-filter-button[data-filter="${ filterName }"][data-filtervalue="${ filterValue }"]` );

	return existingFilterButton ? true : false;

}

/**
 * Remove existing filter buttons if there is no filter checked for them (on mobile)
 *
 * @param {array} mobileFilters
 */
const removeRemainingFilterButtons = ( mobileFilters ) => {

	const filterButtons = document.querySelectorAll( '.js-selected-filters-container .selected-filter-button' );

	if ( filterButtons.length > 0 ) {

		filterButtons.forEach( ( button ) => {

			if ( ! mobileFilters.includes( button.dataset.filtervalue ) ) {

				if ( button.dataset.filter === 'item-search' ) {

					// do not remove search filter button

				} else {

					button.remove();

				}

			}

		} );

	}

}

/**
 * Apply search filters on click 'Filter' button (on mobile)
 */
const applyMobileFilters = () => {

	const mobileFiltersContainer = document.querySelector( '.item-listing__filters' );
	const mobileFiltersButton = mobileFiltersContainer.querySelector( '.item-listing__filters__footer .c-button' );

	if ( mobileFiltersButton && mobileFiltersContainer ) {

		const url = new URL( location );
		const mobileFilters = getSelectedMobileFilters();
		const mobileFiltersFiltered = [];

		// change url parameters
		window.history.pushState( {}, '', url );

		// add filter buttons
		if ( mobileFilters.length > 0 ) {

			mobileFilters.forEach( ( filter ) => {

				if ( ! isFilterButtonExists( filter.name, filter.value ) ) {

					addFilterButton( filter.name, filter.value, filter.text );

				}

				mobileFiltersFiltered.push( filter.value );

			} )

		}

		// remove exists filter buttons if filters are unchecked
		removeRemainingFilterButtons( mobileFiltersFiltered );

		// close mobile filters
		closeAccordions();
		mobileFiltersContainer.classList.remove( 'js-open' );

	}

}

/**
 * Mark Accordion as active
 *
 * @param {boolean} isActive
 * @param {string} filterName
 */
const makeAccodrionActive = ( isActive, filterName ) => {

	const isMobile = window.matchMedia( '(max-width: 992px)' ).matches;
	const accordion = document.querySelector( `.item-listing__filters__dropdown[data-dropdowntrigger="${ filterName }"]` );
	let accordionFilters = document.querySelectorAll( `.item-listing__accordions input[name="${ filterName }[]"]` );

	if ( isMobile ) {

		accordionFilters = document.querySelectorAll( `.item-listing__filters input[name="${ filterName }[]"]` );

	}

	if ( accordion && accordionFilters.length > 0 ) {

		if ( isActive ) {

			accordion.classList.add( 'item-listing__filters__dropdown--active' );

		} else {

			const activeFilters = Array.from( accordionFilters, ( filter ) => filter.checked );

			// if all filters in current accordion are unchecked, remove active class from accordion
			if ( ! activeFilters.includes( true ) ) {

				accordion.classList.remove( 'item-listing__filters__dropdown--active' );

			}

		}

	}

}

/**
 * Handle form submission
 * Add/Remove search filter
 *
 * @param {node} searchInputs
 * @param {node} filtersContainer
 */
const submitSearchForm = ( searchInputs, filtersContainer ) => {

	const filtersForm = document.querySelector( '.item-listing__search' );
	if ( filtersForm !== null ) {

		filtersForm.addEventListener( 'submit', ( e ) => {

			e.preventDefault();

			if ( searchInputs.length > 0 ) {

				searchInputs.forEach( ( searchInput ) => {

					const filterName = searchInput.getAttribute( 'name' );
					const filterValue = searchInput.value.replace( '<', '' ).replace( '>', '' );
					const url = new URL( location );
					const searchFilterButton = document.querySelector( `.selected-filter-button[data-filter="item-search"]` );
					const filtersButtonsContainer = filtersContainer?.querySelector( '.selected-filters__items' );

					if ( filterName && filterValue ) {

						// add/replace search filter param to url
						if ( url.searchParams.has( filterName ) ) {

							url.searchParams.set( filterName, filterValue );

						} else {

							url.searchParams.append( filterName, filterValue );

						}

						// remove search filter button if exists
						if ( searchFilterButton && filtersButtonsContainer ) {

							filtersButtonsContainer.removeChild( searchFilterButton );

						}

						// add search filter button
						addFilterButton( filterName, filterValue, filterValue );

					}

					// remove search filter param and button if search value is empty
					if ( ! filterValue ) {

						url.searchParams.delete( 'item-search' );
						removeFilterButton( filterName, filterValue, url );

					}

					// change url parameters
					window.history.pushState( {}, '', url );

					// load new posts according to selected filters
					applyMobileFilters();
					loadNewPosts();

				} )

			}

		} );

	}

}

/**
 * Add search filters on click (on desktop)
 *
 * @param {node} filters
 * @param {boolean} isMobile
 */
const addFilters = ( filters, isMobile ) => {

	if ( filters.length > 0 ) {

		// add filters only on desktop
		if ( ! isMobile ) {

			filters.forEach( ( filter ) => {

				filter.addEventListener( 'change', () => {

					const filterName = filter.getAttribute( 'name' )?.replace( '[]', '' );
					const filterText = filter.dataset.filtername;
					const filterValue = filter.getAttribute( 'value' );
					const url = new URL( location );
					const currentParameters = url.searchParams.getAll( filterName );

					if ( filterName && filterValue ) {

						if ( filter.checked ) {

							// add filter
							url.searchParams.append( filterName, filterValue );
							makeAccodrionActive( true, filterName );
							addFilterButton( filterName, filterValue, filterText );

						} else if ( currentParameters.includes( filterValue ) ) {

							// remove filter
							url.searchParams.delete( filterName, filterValue );
							makeAccodrionActive( false, filterName );
							removeFilterButton( filterName, filterValue, url );

						}

						// change url parameters
						window.history.pushState( {}, '', url );
						// load new posts according to selected filters
						loadNewPosts();

					}

				} )

			} );

		}

	}

}

/**
 * Create filter buttton with image and text
 * Display filter button
 *
 * @param {string} filterName
 * @param {string} filterValue
 * @param {string} filterText
 */
const addFilterButton = ( filterName, filterValue, filterText ) => {

	const filtersContainer = document.querySelector( '.js-selected-filters-container' );
	const filtersButtonsContainer = filtersContainer?.querySelector( '.selected-filters__items' );
	const loadResultsVars = window.loadResultsVars

	// create filter button
	const filterButton = document.createElement( 'button' );
	const buttonImage = document.createElement( 'img' );
	const buttonText = document.createElement( 'span' );

	filterButton.type = 'button';
	filterButton.setAttribute( 'class', 'selected-filters__item c-button selected-filter-button' );
	filterButton.dataset.filter = filterName;
	filterButton.dataset.filtervalue = filterValue;
	buttonImage.src = `${ loadResultsVars.theme_url }/img/icon-close.svg`;
	buttonImage.setAttribute( 'class', 'search-close-icon' );
	buttonImage.alt = '';
	buttonText.textContent = filterText;
	filterButton.appendChild( buttonImage );
	filterButton.appendChild( buttonText );

	// display filters
	filtersContainer.classList.add( 'has-active-filters' );
	filtersButtonsContainer.appendChild( filterButton );

}

/**
 * Clear all selected filters on click
 *
 * @param {node} filtersContainer
 * @param {node} pageFilters
 * @param {node} togglersFilters
 * @param {node} checkboxesFilters
 */
const handleClearAllFilters = ( filtersContainer, pageFilters, togglersFilters, checkboxesFilters ) => {

	const clearFiltersButton = document.querySelector( '.selected-filters__reset' );

	if ( clearFiltersButton ) {

		clearFiltersButton.addEventListener( 'click', () => {

			clearAllFilters( filtersContainer, pageFilters, togglersFilters, checkboxesFilters );

		} );

	}

}

/**
 * Clear all selected filters
 *
 * @param {node} filtersContainer
 * @param {node} pageFilters
 * @param {node} togglersFilters
 * @param {node} checkboxesFilters
 */
const clearAllFilters = ( filtersContainer, pageFilters, togglersFilters, checkboxesFilters ) => {

	const clearUrl = window.location.href.split( window.location.search );
	const activeAccordions = document.querySelectorAll( '.item-listing__filters__dropdown--active' );
	const filterButtons = document.querySelectorAll( '.selected-filter-button' );
	const searchInput = document.querySelector( '.item-listing__search .c-input-group__post-search' );
	// get cloned pageFilters only
	const pageFiltersMobile = document.querySelectorAll( '.item-listing__filters .js-tax-filter' );

	if ( clearUrl.length > 0 ) {

		// change url parameters
		window.history.pushState( {}, '', clearUrl[ 0 ] );
		// load new posts without any filters
		loadNewPosts();
		// hide filters container
		filtersContainer?.classList.remove( 'has-active-filters' );

		// remove all filters buttons
		if ( filterButtons ) {

			filterButtons.forEach( ( button ) => {

				filtersContainer?.querySelector( '.selected-filters__items' )?.removeChild( button );

			} )

		}

		// uncheck all page filters inputs
		if ( pageFilters ) {

			pageFilters.forEach( ( filter ) => {

				filter.checked = false;

			} );

		}

		// uncheck all page cloned filters inputs - mobile
		if ( pageFiltersMobile ) {

			pageFiltersMobile.forEach( ( filter ) => {

				filter.checked = false;

			} );

		}

		// uncheck all togglers filters inputs
		if ( togglersFilters ) {

			togglersFilters.forEach( ( filter ) => {

				filter.checked = false;

			} );

		}

		// uncheck all checkboxes filters inputs
		if ( checkboxesFilters ) {

			checkboxesFilters.forEach( ( filter ) => {

				filter.checked = false;

			} );

		}

		// remove active class from accordions
		if ( activeAccordions ) {

			activeAccordions.forEach( ( accordion ) => {

				accordion.classList.remove( 'item-listing__filters__dropdown--active' );

			} )

		}

		// clear search input value
		if ( searchInput ) {

			searchInput.value = '';

		}

	}

}

/**
 * Remove single filter on click
 *
 * @param {node} filtersContainer
 */
const removeSingleFilter = ( filtersContainer ) => {

	if ( filtersContainer ) {

		filtersContainer.addEventListener( 'click', ( e ) => {

			const filter = e.target.closest( '.selected-filter-button' );

			if ( filter ) {

				const url = new URL( location );
				const filterType = filter.dataset.filter;
				const filterValue = filter.dataset.filtervalue;
				const searchInput = document.querySelector( '.c-input-group__post-search' );

				if ( filterType === 'item-search' && searchInput ) {

					// remove search input filter
					searchInput.value = '';
					url.searchParams.delete( filterType );

				} else {

					// uncheck all checked inputs
					const input = document.querySelector( `input[name="${ filterType }[]"][value="${ filterValue }"]` );
					input.checked = false;

					// remove taxonomy filter from url
					url.searchParams.delete( filterType, filterValue );
					makeAccodrionActive( false, filterType );

				}

				// change url parameters
				window.history.pushState( {}, '', url );
				removeFilterButton( filterType, filterValue, url );
				loadNewPosts();

			}

		} );

	}

}

/**
 * Remove filter buttton
 *
 * @param {string} filterName
 * @param {string} filterValue
 * @param {node} url
 */
const removeFilterButton = ( filterName, filterValue, url ) => {

	const filtersContainer = document.querySelector( '.js-selected-filters-container' );
	const filterButton = document.querySelector( `.selected-filter-button[data-filter="${ filterName }"][data-filtervalue="${ filterValue }"]` );

	if ( filterButton && filtersContainer ) {

		// remove filter button
		filtersContainer.querySelector( '.selected-filters__items' )?.removeChild( filterButton );

	}

	if ( url.searchParams.size === 0 ) {

		// hide filters container
		filtersContainer.classList.remove( 'has-active-filters' );

	}

}

/**
 * Remove all childNodes of given parent
 *
 * @param {node} parent
 */
const removeAllChildNodes = ( parent ) => {

	while ( parent.firstChild ) {

		parent.removeChild( parent.firstChild );

	}

}

/**
 * Load more posts on click
 */
const loadMorePosts = () => {

	const loadMoreButton = document.querySelector( '.js-load-more-posts-button' );

	if ( loadMoreButton ) {

		loadMoreButton.addEventListener( 'click', () => {

			loadAjax( loadMoreButton );

		} )

	}

}

/**
 * Reset posts list and load new posts
 */
const loadNewPosts = () => {

	const postsContainer = document.querySelector( '.posts-grid.container' );
	const loadMoreButton = document.querySelector( '.js-load-more-posts-button' );
	// remove all posts
	removeAllChildNodes( postsContainer );
	if ( loadMoreButton ) {

		// set paged attriubte to 1
		loadMoreButton.dataset.paged = 1;
		// load filtered posts
		loadAjax( loadMoreButton );

	} else {

		// load filtered posts
		loadAjax( loadMoreButton );

	}

}

/**
 * Get new posts by ajax
 *
 * @param {node} loadMoreButton
 */
const loadAjax = ( loadMoreButton = false ) => {

	const loadResultsVars = window.loadResultsVars
	const paged = loadMoreButton ? loadMoreButton.dataset.paged : 1;
	const filters = new URLSearchParams( window.location.search ).toString();

	fetch( loadResultsVars.url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			Pragma: 'no-cache',
			Expires: '0',
		},
		body: new URLSearchParams( {
			action: `load_results_${ loadResultsVars.post_type }`,
			nonce: loadResultsVars.nonce,
			paged: paged,
			filters: filters,
			postType: loadResultsVars.post_type,
		} ),
	} ).then( ( response ) => {

		return response.json();

	} ).then( ( response ) => {

		if ( response.data?.output !== undefined ) {

			const postsContainer = document.querySelector( '.posts-grid.container' );
			const range = document.createRange();
			const fragment = range.createContextualFragment( response.data.output );

			postsContainer.appendChild( fragment );

			if ( loadMoreButton ) {

				loadMoreButton.dataset.paged = parseInt( paged ) + 1;

				if ( response.data?.end ) {

					loadMoreButton.classList.add( 'disabled' );

				} else {

					loadMoreButton.classList.remove( 'disabled' );

				}

			}

			switchImages();

		}

	} ).catch( () => {

		//console.log( 'Error parsing JSON:', error );

	} );

}

/**
 * Search Filters logic
 */
export const searchFilters = () => {

	const pageFilters = document.querySelectorAll( '.item-listing__accordions .js-tax-filter' );
	const togglersFilters = document.querySelectorAll( '.c-toggle-control__input' );
	const checkboxesFilters = document.querySelectorAll( '.c-checkbox-control__input' );
	const searchInputs = document.querySelectorAll( '.c-input-group__post-search' );
	const filtersContainer = document.querySelector( '.js-selected-filters-container' );
	const isMobile = window.matchMedia( '(max-width: 992px)' ).matches;

	// open/close filters
	toggleMobileFilters( filtersContainer, togglersFilters, checkboxesFilters );
	toggleFilterDropdown( togglersFilters, isMobile );
	// add filters for all filter inputs
	addFilters( pageFilters, isMobile );
	addFilters( togglersFilters, isMobile );
	addFilters( checkboxesFilters, isMobile );
	// applyMobileFilters();
	submitSearchForm( searchInputs, filtersContainer );
	// clear filters
	handleClearAllFilters( filtersContainer, pageFilters, togglersFilters, checkboxesFilters );
	removeSingleFilter( filtersContainer );
	// load more posts
	loadMorePosts();

}
